export default __webpack_public_path__ + "static/media/scheduleImg.37ec6802.png";